import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { CookieBanner } from '@/components/CookieBanner';
import { StickyCta } from '@/components/StickyCta';
import { subscribeConsent } from '@/lib/cookieConsent';
import { applyConsentServices } from '@/lib/consentServices';
import { isMobileLanding } from '@/lib/isMobileLanding';
import { trackLandingPageView } from '@/lib/tracking';

const PUBLIC_PATHS = new Set(['/', '/prueba-agentes']);

function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.has(pathname);
}

export function PublicShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const showPublicChrome = isPublicPath(pathname);
  const mobileHome = pathname === '/' && isMobileLanding();

  useEffect(() => {
    if (!showPublicChrome) return;
    return subscribeConsent((consent) => {
      if (consent?.analytics) {
        trackLandingPageView(pathname);
      }
      if (consent) applyConsentServices(consent);
    });
  }, [showPublicChrome, pathname]);

  return (
    <>
      {children}
      {showPublicChrome ? (
        <>
          <CookieBanner />
          {mobileHome ? null : <StickyCta />}
        </>
      ) : null}
    </>
  );
}
